<ng-template #eta>
  <app-date-field
    [ngModel]="berthVisit.eta" (ngModelChange)="onEtaChanged($event)"
    [required]="isZeelandPort() || isPlanningBasedOnFirstBerth() || berthVisit.terminalPlanningEnabled"
    [calendarStartDate]="berthVisit.ata || berthVisit.etd"
    [disabled]="editEtaDisabled"
    id="{{berthVisit.id}}-eta"
    [appCompare]="rtaOrEtaQuarterHour" [compareFormatter]="formatDate" [showComparison]="false">
  </app-date-field>
  @if (showUseTerminalRtaRequest()) {
    <div style="text-align: end;">
      <input type="checkbox" [ngModel]="etaMatchesRta()" (ngModelChange)="useTerminalRta($event)"/>
      &nbsp;Use Requested Arrival
      <app-info>
        <span class="tooltipContent">Use Requested Arrival from terminal, rounded to nearest quarter</span>
      </app-info>
    </div>
  }
  @if (previousBerthVisitNotChronological()) {
    <span class="ng-invalid invalid-feedback mb-2">
      ETA is before the departure of the previous berth
    </span>
  }
</ng-template>

<ng-template #etd>
  <app-tidal-window [status]="getBerthVisitInfo()?.harbourMasterInfo?.tidalWindowStatus"
    [level]="berthVisit.nextMovement?.order ? 'error' : 'warning'">
    <app-date-field [ngModel]="berthVisit.etd" (ngModelChange)="onEtdChanged($event)"
      [calendarStartDate]="berthVisit.ata || berthVisit.eta"
      [required]="berthVisit.nextMovement.order || berthVisit.terminalPlanningEnabled"
      id="{{berthVisit.id}}-etd" [disabled]="!!berthVisit.atd"
    class="{{etdMatchesEtc() ? '' : 'has-diff'}}"></app-date-field>
    @if (showUseTerminalEtcRequest()) {
      <div style="text-align: end;">
        <input type="checkbox" [ngModel]="etdMatchesEtc()" (ngModelChange)="useTerminalEtc($event)"/>
        &nbsp;Use Estimated Completion
        <app-info>
          <span class="tooltipContent">Use Estimated Completion from Terminal, rounded to nearest quarter</span>
        </app-info>
      </div>
    }
  </app-tidal-window>
  @if (berthVisitNotChronological()) {
    <span class="ng-invalid invalid-feedback mb-2">
      Departure should be after arrival
    </span>
  }
</ng-template>

<ng-template #lastEtd>
  <app-date-field [(ngModel)]="lastBerthVisitDeparture().etd" [required]="berthVisit.terminalPlanningEnabled"
  [calendarStartDate]="berthVisit.ata || berthVisit.eta" id="lastBerthVisit"></app-date-field>
  @if (berthVisitNotChronological()) {
    <span class="ng-invalid invalid-feedback mb-2">
      Departure should be after arrival
    </span>
  }
</ng-template>
@for (entry of sortedEntries; track entry.id; let index = $index; let last = $last) {
  <app-labeled-date-time [info]="entry" [index]="index" [last]="last"></app-labeled-date-time>
}
